import { select } from "d3-selection"
import { eachQuickAddZone } from "./drag_zones"

// Inject 4 "+" buttons as children of the given tree-node <g> element.
// They are removed by `clearQuickAddOverlay` on mouseleave. While the overlay
// is on, sibling collapse buttons are hidden (they share the same y as the "+"
// bottom; the user reaches them again as soon as hover ends).
export function showQuickAddOverlay(nodeGroupEl, personId) {
  if (!nodeGroupEl || !personId) return
  if (nodeGroupEl.querySelector(".tree-node__quick-add")) return // already shown
  nodeGroupEl.querySelectorAll(".tree-node__collapse-btn, .tree-node__collapse-icon")
             .forEach(el => el.classList.add("tree-node__collapse-btn--hidden-on-hover"))

  const g = select(nodeGroupEl)
  eachQuickAddZone((zone, offset, relationKind) => {
    const btn = g.append("g")
      .attr("class", `tree-node__quick-add tree-node__quick-add--${zone}`)
      .attr("data-relation-kind", relationKind)
      .attr("data-zone", zone)
      .attr("data-person-id", personId)
      .attr("transform", `translate(${offset.dx},${offset.dy})`)

    btn.append("circle").attr("r", 14).attr("class", "tree-node__quick-add-bg")
    btn.append("text")
      .attr("text-anchor", "middle").attr("y", 4)
      .attr("class", "tree-node__quick-add-icon")
      .text("+")
      .style("pointer-events", "none")
  })
}

export function clearQuickAddOverlay(nodeGroupEl) {
  if (!nodeGroupEl) return
  nodeGroupEl.querySelectorAll(".tree-node__quick-add").forEach(n => n.remove())
  nodeGroupEl.querySelectorAll(".tree-node__collapse-btn--hidden-on-hover")
             .forEach(el => el.classList.remove("tree-node__collapse-btn--hidden-on-hover"))
}
